import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import API from './api';
import Settings from './constants/Settings';

/**
 * Transforms the Contentful API response into the key-value
 * format i18next expects.
 *
 * @param {Array} entries - The array of entries from Contentful
 * @returns {Object} A simple { key: "translation" } object
 */
const formatContentfulData = (entries) => {
  if (!entries || entries.length === 0) {
    return {};
  }

  return entries.reduce((acc, entry) => {
    // Assumes your fields are named 'key' and 'translation'
    if (entry.fields.key && entry.fields.translation) {
      acc[entry.fields.key] = entry.fields.translation;
    }
    return acc;
  }, {});
};

/**
 * Our custom i18next backend for Contentful.
 */
const contentfulBackend = {
  type: "backend",
  init: () => {}, // No-op,
  async read(language, namespace, callback) {
    try {
      // Fetch entries from Contentful
      const useLanguage = language.toLowerCase() === 'en-uk' ? 'en-GB' : language;
      const entries = await API.getDictionary(useLanguage);
      const translations = formatContentfulData(entries.items);
      callback(null, translations);
    } catch (error) {
      console.error("Error fetching translations from Contentful:", error);
      callback(error, null);
    }
  },
  // We don't need create/update operations for this use case
  create: () => {},
  update: () => {},
};

i18n.use(LanguageDetector)
 .use(contentfulBackend) // Use our custom backend
 .init({
  supportedLngs: Settings.Languages, // Languages we're supporting.
  fallbackLng: "en-us",
  initImmediate: false, // Load resources synchronously
  initAsync: false,
  load: 'currentOnly', // only load the current language code
  debug: false,
  // have a common namespace used around the full app
  ns: ["translations"],
  defaultNS: "translations",
  keySeparator: false, // we use content as keys
  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ","
  },
  react: {
    wait: false,
    useSuspense: true
  }
});

export default i18n;
